interface SearchTokenProps {
  token: string;
  onRemove: () => void;
  onEdit: () => void;
}

export default function SearchToken({
  token,
  onRemove,
  onEdit,
}: SearchTokenProps) {
  return (
    <div className="token js-token">
      <button className="edit js-token-edit" title="Edit" onClick={onEdit}>
        {token}
      </button>
      <button
        className="remove close-custom js-token-remove"
        title="Remove"
        onClick={onRemove}
      ></button>
    </div>
  );
}
